
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 2H5a1 1 0 00-1 1v2H3V3a2 2 0 012-2h6a2 2 0 012 2v2h-1V3a1 1 0 00-1-1zM14 6H2a1 1 0 00-1 1v3a1 1 0 001 1h1v1H2a2 2 0 01-2-2V7a2 2 0 012-2h12a2 2 0 012 2v3a2 2 0 01-2 2h-1v-1h1a1 1 0 001-1V7a1 1 0 00-1-1z","fill":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11 9H5a1 1 0 00-1 1v3a1 1 0 001 1h6a1 1 0 001-1v-3a1 1 0 00-1-1zM5 8a2 2 0 00-2 2v3a2 2 0 002 2h6a2 2 0 002-2v-3a2 2 0 00-2-2H5z","fill":"#000"}}),_c('path',{attrs:{"d":"M3 7.5a.5.5 0 11-1 0 .5.5 0 011 0z","fill":"#000"}})])
          )
        }
      }
    